// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-page {
  width: min(980px, 100% - 24px);
  margin: 16px auto 32px;
  padding: 14px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));
}

.notifications-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
  position: sticky;
  top: 99px;
  z-index: 99;
  background: linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));
  padding: 14px 0;
  margin-top: -14px;
}

.App.header-layout .notifications-toolbar {
  top: 159px;
}

.notifications-toolbar-left,
.notifications-toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.notifications-toolbar-left {
  flex: 1 1 auto;
  min-width: 0;
}

.notifications-group-drill-header {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.notifications-group-drill-label {
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.notifications-select-all {
  display: none;
  align-items: center;
  gap: 8px;
  font-size: 0.92rem;
}

.notifications-count {
  font-size: 0.86rem;
  color: var(--text-secondary);
}

.notifications-unread-toggle-wrap {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.notifications-unread-toggle-label {
  font-size: 0.86rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.notifications-unread-toggle {
  position: relative;
  display: flex;
  align-items: center;
  width: 90px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid var(--input-border);
  background: var(--bg-secondary);
  cursor: pointer;
}

.notifications-unread-toggle-option {
  flex: 1 1;
  text-align: center;
  padding: 4px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
  z-index: 1;
}

.notifications-unread-toggle-option.active {
  color: var(--accent-primary);
}

.notifications-unread-toggle-slider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  background: var(--bg-primary);
  border-radius: 999px;
  box-shadow: 0 2px 8px var(--shadow-color);
  transition: transform 0.2s ease;
}

.notifications-unread-toggle.right .notifications-unread-toggle-slider {
  transform: translateX(100%);
}

.notif-btn {
  border: 1px solid var(--accent-primary);
  background: var(--accent-primary);
  color: #fff;
  border-radius: 8px;
  padding: 7px 12px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
}

.notif-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.notif-btn-secondary {
  background: transparent;
  color: var(--text-primary);
  border-color: var(--input-border);
}

.notifications-state {
  padding: 20px 8px;
  text-align: center;
  color: var(--text-secondary);
}

.notifications-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notifications-separator {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0;
  color: var(--text-secondary);
  font-size: 0.8rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.notifications-separator::before,
.notifications-separator::after {
  content: '';
  height: 1px;
  flex: 1 1;
  background: var(--border-color);
}

.notification-item {
  display: grid;
  grid-template-columns: 34px 1fr auto;
  gap: 12px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 10px;
  background: var(--bg-secondary);
}

.notification-item.unread {
  box-shadow: inset 3px 0 0 var(--accent-primary);
}

.notification-item.read {
  opacity: 0.88;
}

.notification-item.muted-user {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border-style: dashed;
}

.notification-select-col {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 3px;
}

.notification-read-dot {
  color: var(--text-secondary);
  font-size: 0.82rem;
}

.notification-main-col {
  min-width: 0;
}

.notification-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 0.88rem;
}

.notification-title-row span {
  color: var(--text-secondary);
  font-size: 0.8rem;
  white-space: nowrap;
}

.notiflexion-subcount {
  margin-left: 6px;
  font-size: 0.76rem;
  padding: 1px 7px;
  border-radius: 999px;
  background: var(--accent-primary);
  color: #fff;
  font-weight: 700;
}

.notification-summary {
  margin-top: 5px;
  font-size: 0.92rem;
  color: var(--text-primary);
  word-break: break-word;
}

.notification-summary-link {
  border: 0;
  background: transparent;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.notification-user-link {
  color: var(--accent-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.notification-user-link:hover {
  color: var(--accent-hover);
}

.notification-meta {
  margin-top: 5px;
  color: var(--text-secondary);
  font-size: 0.82rem;
  word-break: break-word;
}

.notification-snippet {
  margin-top: 6px;
  color: var(--text-secondary);
  font-size: 0.82rem;
  line-height: 1.35;
  word-break: break-word;
}

.notification-permlink {
  margin-top: 5px;
  display: inline-flex;
  border: 0;
  background: transparent;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 0;
  font-size: 0.8rem;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.notification-actions-col {
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: flex-end;
}

.notif-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 0.78rem;
  padding: 5px 10px;
  cursor: pointer;
}

.notif-link-btn:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.notif-link-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.notif-link-btn:disabled:hover {
  border-color: var(--input-border);
  color: var(--text-primary);
}

.notif-delete-btn {
  border-color: rgba(190, 50, 50, 0.5);
  color: #b64141;
}

.notif-delete-btn:hover {
  border-color: #b64141;
  color: #b64141;
}

.notif-filter-wrap {
  position: relative;
}

.notif-filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.notif-filter-btn.notif-filter-active {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.notif-filter-caret {
  font-size: 0.75rem;
  line-height: 1;
}

.notif-filter-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 200;
  min-width: 170px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 8px 0;
  box-shadow: 0 6px 20px var(--shadow-color);
}

.notif-filter-toggle-all {
  display: block;
  width: 100%;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--border-color);
  padding: 6px 14px 8px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--accent-primary);
  cursor: pointer;
  margin-bottom: 4px;
}

.notif-filter-toggle-all:hover {
  background: var(--bg-hover, var(--bg-primary));
}

.notif-filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px;
  font-size: 0.88rem;
  color: var(--text-primary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.notif-filter-item:hover {
  background: var(--bg-hover, var(--bg-primary));
}

.notif-filter-item input[type='checkbox'] {
  cursor: pointer;
}

@media (max-width: 760px) {
  .notifications-unread-toggle-wrap {
    margin-left: 0;
  }

  .notification-item {
    grid-template-columns: 30px 1fr;
  }

  .notification-actions-col {
    grid-column: 2;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notifications.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,2EAA2E;EAC3E,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,SAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".notifications-page {\r\n  width: min(980px, 100% - 24px);\r\n  margin: 16px auto 32px;\r\n  padding: 14px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 14px;\r\n  background: linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));\r\n}\r\n\r\n.notifications-toolbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 14px;\r\n  flex-wrap: wrap;\r\n  position: sticky;\r\n  top: 99px;\r\n  z-index: 99;\r\n  background: linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));\r\n  padding: 14px 0;\r\n  margin-top: -14px;\r\n}\r\n\r\n.App.header-layout .notifications-toolbar {\r\n  top: 159px;\r\n}\r\n\r\n.notifications-toolbar-left,\r\n.notifications-toolbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.notifications-toolbar-left {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.notifications-group-drill-header {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-left: auto;\r\n}\r\n\r\n.notifications-group-drill-label {\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.notifications-select-all {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.notifications-count {\r\n  font-size: 0.86rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.notifications-unread-toggle-wrap {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.notifications-unread-toggle-label {\r\n  font-size: 0.86rem;\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.notifications-unread-toggle {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 90px;\r\n  padding: 4px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--input-border);\r\n  background: var(--bg-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.notifications-unread-toggle-option {\r\n  flex: 1;\r\n  text-align: center;\r\n  padding: 4px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  z-index: 1;\r\n}\r\n\r\n.notifications-unread-toggle-option.active {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.notifications-unread-toggle-slider {\r\n  position: absolute;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  left: 4px;\r\n  width: calc(50% - 4px);\r\n  background: var(--bg-primary);\r\n  border-radius: 999px;\r\n  box-shadow: 0 2px 8px var(--shadow-color);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.notifications-unread-toggle.right .notifications-unread-toggle-slider {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.notif-btn {\r\n  border: 1px solid var(--accent-primary);\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 7px 12px;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.notif-btn:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.notif-btn-secondary {\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  border-color: var(--input-border);\r\n}\r\n\r\n.notifications-state {\r\n  padding: 20px 8px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.notifications-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.notifications-separator {\r\n  list-style: none;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin: 4px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.notifications-separator::before,\r\n.notifications-separator::after {\r\n  content: '';\r\n  height: 1px;\r\n  flex: 1;\r\n  background: var(--border-color);\r\n}\r\n\r\n.notification-item {\r\n  display: grid;\r\n  grid-template-columns: 34px 1fr auto;\r\n  gap: 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 10px;\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.notification-item.unread {\r\n  box-shadow: inset 3px 0 0 var(--accent-primary);\r\n}\r\n\r\n.notification-item.read {\r\n  opacity: 0.88;\r\n}\r\n\r\n.notification-item.muted-user {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-secondary);\r\n  border-style: dashed;\r\n}\r\n\r\n.notification-select-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  padding-top: 3px;\r\n}\r\n\r\n.notification-read-dot {\r\n  color: var(--text-secondary);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.notification-main-col {\r\n  min-width: 0;\r\n}\r\n\r\n.notification-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.notification-title-row span {\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.notiflexion-subcount {\r\n  margin-left: 6px;\r\n  font-size: 0.76rem;\r\n  padding: 1px 7px;\r\n  border-radius: 999px;\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n\r\n.notification-summary {\r\n  margin-top: 5px;\r\n  font-size: 0.92rem;\r\n  color: var(--text-primary);\r\n  word-break: break-word;\r\n}\r\n\r\n.notification-summary-link {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  font-size: inherit;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.notification-user-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.notification-user-link:hover {\r\n  color: var(--accent-hover);\r\n}\r\n\r\n.notification-meta {\r\n  margin-top: 5px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.82rem;\r\n  word-break: break-word;\r\n}\r\n\r\n.notification-snippet {\r\n  margin-top: 6px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.82rem;\r\n  line-height: 1.35;\r\n  word-break: break-word;\r\n}\r\n\r\n.notification-permlink {\r\n  margin-top: 5px;\r\n  display: inline-flex;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  font-size: 0.8rem;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.notification-actions-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  align-items: flex-end;\r\n}\r\n\r\n.notif-link-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  font-size: 0.78rem;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.notif-link-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.notif-link-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.notif-link-btn:disabled:hover {\r\n  border-color: var(--input-border);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.notif-delete-btn {\r\n  border-color: rgba(190, 50, 50, 0.5);\r\n  color: #b64141;\r\n}\r\n\r\n.notif-delete-btn:hover {\r\n  border-color: #b64141;\r\n  color: #b64141;\r\n}\r\n\r\n.notif-filter-wrap {\r\n  position: relative;\r\n}\r\n\r\n.notif-filter-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.notif-filter-btn.notif-filter-active {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.notif-filter-caret {\r\n  font-size: 0.75rem;\r\n  line-height: 1;\r\n}\r\n\r\n.notif-filter-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  right: 0;\r\n  z-index: 200;\r\n  min-width: 170px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  padding: 8px 0;\r\n  box-shadow: 0 6px 20px var(--shadow-color);\r\n}\r\n\r\n.notif-filter-toggle-all {\r\n  display: block;\r\n  width: 100%;\r\n  background: transparent;\r\n  border: 0;\r\n  border-bottom: 1px solid var(--border-color);\r\n  padding: 6px 14px 8px;\r\n  text-align: left;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.notif-filter-toggle-all:hover {\r\n  background: var(--bg-hover, var(--bg-primary));\r\n}\r\n\r\n.notif-filter-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 5px 14px;\r\n  font-size: 0.88rem;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.notif-filter-item:hover {\r\n  background: var(--bg-hover, var(--bg-primary));\r\n}\r\n\r\n.notif-filter-item input[type='checkbox'] {\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .notifications-unread-toggle-wrap {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .notification-item {\r\n    grid-template-columns: 30px 1fr;\r\n  }\r\n\r\n  .notification-actions-col {\r\n    grid-column: 2;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    margin-top: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
